// extracted by mini-css-extract-plugin
module.exports = {"root":"employee-activities-monitor_root__rH79m","list":"employee-activities-monitor_list__nYatD","card":"employee-activities-monitor_card__1I3cY"};